export default {
  SELECTED_ORIGINS_KEY: 'selectedOrigins',
  SELECTED_DESTINATIONS_KEY: 'selectedDestinations',
  SELECTED_DATES_KEY: 'selectedDates',
  SELECTED_ROOM_CONFIGURATIONS_KEY: 'selectedRoomConfigurations',
};
